<template>
  <div class="about">
    <time-line/>
  </div>
</template>

<script>

import TimeLine from '@/components/TimeLine'

export default {
  components:{
    TimeLine
  }
}
</script>